import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { RefreshDialogComponent } from '../dialogs/refresh-dialog/refresh-dialog.component';


@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.css'],
})
export class BodyComponent implements OnInit {
  @Input() collapsed = false;
  @Input() screenWidth = 0;
  currentTabId: number = 0;
  currentTabName: string = '';
  currentTabType: string = '';
  screen: string = '';
  paramId: number = 0;
  item: any;
  constructor(
    public dynamicTabService: DynamicTabsService,
    private router: Router,
    private dialog: MatDialog,
    private actRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.actRoute.queryParams.subscribe(params => {
      this.screen = params["screen"];
      this.paramId = +params["MasterPolicyId"]
      let id = params["UserId"];
      //  sessionStorage.setItem('userId',id);

      if (this.screen == "MasterPolicyDetail") {
        if (this.paramId > 0) {
          // this.item.id=this.paramId;
          // this.item.label="Master Policy Detail";
          // this.item.type="policy"
          // this.openDetailTab(this.item);
          // this.item = {routerLink: 'main/home',label: 'Home',type: 'policy'}
          this.item = { id: this.paramId, label: "Master Policy Detail", routerLink: "Policy Details", type: "policy", };
          this.openDetailTab(this.item);
          // this.dynamicTabService.createTabsFromNavbarData(this.item);
        }
      }
      else if (this.screen == "AssociationAdd") {
        this.item = { id: -7, routerLink: 'AssnAddNew', label: 'Add New' };
        this.dynamicTabService.createTabsFromNavbarData(this.item);
      }
      else if (this.screen == "AbandonedGoApps") {
        this.item = { id: -11, routerLink: 'guides/abandoned', label: 'Abandoned Apps' };
        this.dynamicTabService.createTabsFromNavbarData(this.item);
      }
    });
  }

  openDetailTab(item: any) {
    this.currentTabId = item.id;
    this.currentTabName = item.label;
    this.currentTabType = item.type;
    this.dynamicTabService.createTabsFromNavbarData({ id: this.currentTabId, label: this.currentTabName, routerLink: this.currentTabName, type: this.currentTabType });
  }

  getBodyClass(): string {
    let styleClass = '';

    if (this.collapsed && this.screenWidth > 768) {
      styleClass = 'body-trimmed';
    } else if (this.collapsed && this.screenWidth <= 768) {
      styleClass = 'body-md-screen';
    }

    return styleClass;
  }

  getTabs(): { label: string; isActive: boolean; routerLink: string; closable: boolean }[] {
    return this.dynamicTabService.tabs;
  }

  openTab(tab: any): void {

    this.dynamicTabService.tabs.forEach(tab => tab.isActive = false);
    tab.isActive = true;
    if ((tab.type == 'association') || (tab.type == 'policy')) {
      this.currentTabName = tab.label;
      this.currentTabId = tab.id;
      
    }
    this.dynamicTabService.selectedTabData = tab;
    this.dynamicTabService.selectedTab = tab.label;

  }

  closeTab(tab: any): void {
    tab.closable=true
    this.dynamicTabService.closeTabId = tab.id;
    this.dynamicTabService.closableTab = tab;
    
    if (tab.closable == ((tab.id == -8) || (tab.id == -6) || (tab.id == -9) || (tab.id == -11))) {
      const currentIndex = this.dynamicTabService.getIndexByTab(tab);
      this.dynamicTabService.removeTab(tab);
      const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;

      // If there are remaining tabs, navigate to the previous tab's URL
      const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
      const nextTab = this.dynamicTabService.tabs[currentIndex];

      if (previousTab && actTab <= 0  ) {
        previousTab.isActive = true;
        this.openTab(previousTab);
      }
      else if (nextTab && actTab <= 0) {
        nextTab.isActive = true;
        this.openTab(nextTab);
      }
      else if (actTab == 0) {
        this.dynamicTabService.closeTab(actTab);

      }
      // else {
      //   // If no previous tab, navigate to the default URL
      //   this.router.navigate(['/']);
      // }
    }
    
    else {
      sessionStorage.setItem('closeBtn', 'true');
      this.dynamicTabService.closingTab();

    }


  }

  forceCloseTab(tab: any): void {
    this.dynamicTabService.closeTabId = tab.id;
    // this.closeSub.unsubscribe();
    if (tab.closable) {
      this.dynamicTabService.closableTab.closable=false;
      const currentIndex = this.dynamicTabService.getIndexByTab(tab);
      this.dynamicTabService.removeTab(tab);
      const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
      // If there are remaining tabs, navigate to the previous tab's URL
      const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
      const nextTab = this.dynamicTabService.tabs[currentIndex];
      if (previousTab && actTab <= 0) {
        previousTab.isActive = true;
        this.openDetailTab(previousTab);

        // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
      }
      else if (nextTab && actTab <= 0) {
        nextTab.isActive = true;
        this.openDetailTab(nextTab);
      }
      else if (actTab == 0) {
        this.closeTab(actTab);
      }
      // else {
      //   // If no previous tab, navigate to the default URL
      //   this.router.navigate(['/']);
      // }
    }

  }

}